import angular from "angular";
import RequestService from "app/services/RequestService";
import ConfigService from "app/services/ConfigService";
import Utils from "./Utils.js";
import cookies from "angular-cookies";
import ServiceRA from "app/services/ServiceRA";
import Events from "app/services/Events";
import angularCookies from "angular-cookies";
import TreeFilterService from "./TreeFilterService";
import FeatureService from "./FeatureService";
import User from "./User";

export default angular
  .module("services.AuthenticationService", [
    angularCookies,
    FeatureService,
    Events,
    RequestService,
    Utils,
    cookies,
    ServiceRA,
    TreeFilterService,
    ConfigService,
  ])
  .factory("User", User)
  .factory("AuthenticationService", [
    "$analytics",
    "FeatureService",
    "Events",
    "RequestService",
    "$http",
    "$log",
    "$q",
    "$state",
    "$rootScope",
    "$timeout",
    "ServiceRA",
    "Utils",
    "$cookies",
    "$window",
    "TreeFilterService",
    "ConfigService",
    "User",
    function AuthenticationService(
      $analytics,
      FeatureService,
      Events,
      RequestService,
      $http,
      $log,
      $q,
      $state,
      $rootScope,
      $timeout,
      ServiceRA,
      Utils,
      $cookies,
      $window,
      TreeFilterService,
      ConfigService,
      User
    ) {
      //var user;
      var authenticated = false;
      var demoInfoWasShown = false;
      var demoUser;
      var resetFeature = true;
      var checkSessionTimeout = null;
      var context = "CON";
      var selectedContract;

      var states = {
        logout: "login",
        home: "dashboard",
        error: "error",
      };

      function clearGDPRCookies() {
        $cookies.put("__cle", "declined");
        $cookies.put("_cleGDPR", false);
        // $rootScope.$emit(Events.RELOAD_COOKIEBAR);
        // Reload Cookie Bar; How?!?!
      }

      function clearCookies() {
        $cookies.remove("XSRF-TOKEN");
        $cookies.remove("JWT");
      }

      function clear() {
        clearCookies();
        sessionStorage.removeItem("loginSucceeded");
        TreeFilterService.setTree(null);
        clearSessionTimeout();
      }

      init();

      function init() {
        context = ConfigService.getContext();

        var xsrfToken;
        xsrfToken = $cookies.get("XSRF-TOKEN");

        if (xsrfToken) {
          $http.defaults.headers.common["X-XSRF-TOKEN"] = xsrfToken;
          reloadUser();

          xsrfToken = $cookies.get("XSRF-TOKEN");
          setToken(xsrfToken);
        }
      }

      function setResetFeature(value) {
        resetFeature = value;
      }

      function getResetFeature() {
        return resetFeature;
      }

      function demoInfoShown() {
        return demoInfoWasShown;
      }

      function showDemoInfo() {
        demoInfoWasShown = true;
      }

      function showDemoInfoAgain() {
        demoInfoWasShown = false;
      }

      function setToken(token) {
        if (!token) {
          authenticated = false;
        } else {
          authenticated = true;
        }
      }

      function setUser(_user) {
        //console.log("set user : ", _user);
        User.set(_user); //user = _user;
        FeatureService.setFeatures([]);
        if (_user) {
          if (isSwitchedUser(_user)) {
            FeatureService.setFeatures(
              _user.actingAsUser.effectiveFeatures || _user.effectiveFeatures
            );
            FeatureService.setUseGloballyDisabledFeatures(false);
          } else {
            FeatureService.setFeatures(_user.effectiveFeatures);
            FeatureService.setUseGloballyDisabledFeatures(true);
          }
        }
        let user = User.get();
        if (user !== null && user !== undefined) {
          $rootScope.$emit(Events.USER_CHANGED, user);
        }
      }

      function getUser() {
        var defer = $q.defer();
        let user = User.get();
        if (user) {
          defer.resolve(user);
        } else {
          reloadUser().then(defer.resolve, defer.reject);
        }
        return defer.promise;
      }

      function getUserWithoutReload() {
        return User.get();
      }

      function loadActingAsUser(data) {
        var defer = $q.defer();
        if (_.get(data, "actingAsUser._id")) {
          ServiceRA.one("users", _.get(data, "actingAsUser._id"))
            .get()
            .then(function (actingAsUserData) {
              defer.resolve(actingAsUserData);
            });
        } else {
          defer.resolve({});
        }
        return defer.promise;
      }

      function reloadUser() {
        var defer = $q.defer();
        authenticated = false;
        ServiceRA.one("whoami")
          .get()
          .then(function (data) {
            ServiceRA.one("users", data._id)
              .get()
              .then(function (userData) {
                loadActingAsUser(data).then(function (actingAsUserData) {
                  // ServiceRA.one("users", _.get(data, "actingAsUser._id")).get().then(function (actingAsUserData) {
                  let user = _.assign(data.plain(), userData.plain());
                  if (!_.isEmpty(actingAsUserData)) {
                    user.actingAsUser = actingAsUserData;
                  }
                  setUser(user);

                  authenticated = true;
                  demoUser =
                    user.username === ConfigService.get("demo.user", true);
                  defer.resolve(user);
                }, defer.reject);
              }, defer.reject);
          }, defer.reject);

        return defer.promise;
      }

      function login(username, password) {
        clear();
        var defer = $q.defer();
        authenticated = false;
        //TreeFilterService.items = []; //clearTreeFilter();
        //$rootScope.$emit("clearTree");
        //TreeFilterService = {};

        var headers = Utils.prepareHeaders("login");

        // demo@dinersclub.at
        if (username === ConfigService.get("demo.user", true)) {
          demoUser = true;
          password = ConfigService.get("demo.password", true);
        } else {
          demoUser = false;
        }

        ServiceRA.all("authenticate")
          .post(
            {
              username: username,
              email: username,
              password: password,
              context: context,
            },
            null,
            headers
          )
          .then(
            function (data) {
              // store token
              // setToken(data.token);
              $analytics.setUserProperties(data._id, {
                name: data.firstName + " " + data.lastName,
                username: data.email,
                email: data.email,
              });
              $timeout(function () {
                setUser(data.plain());
                authenticated = true;
                $http.defaults.headers.common["X-XSRF-TOKEN"] =
                  $cookies.get("XSRF-TOKEN");
                defer.resolve(data);
              }, 200);
            },
            function (err) {
              defer.reject(err);
            }
          );

        return defer.promise;
      }

      function logout(
        state,
        params,
        externalState,
        additionalHeaders,
        forceReload
      ) {
        var s = states.logout;
        var p = params || {};
        if (state) {
          s = state;
        }

        var headers = Utils.prepareHeaders("logout");

        if (additionalHeaders) {
          headers = Utils.prepareHeaders(additionalHeaders);
        }

        $rootScope.$emit(Events.LOGOUT);

        RequestService.cancelAll();
        ServiceRA.all("logout")
          .withHttpConfig({
            isException: true,
          })
          .post(null, null, headers)
          .then(
            function (data) {
              logoutWithoutRequest($state, s, p, externalState, forceReload);
              authenticated = false;
            },
            function (err) {
              logoutWithoutRequest($state, s, p, externalState, forceReload);
            }
          );
      }

      function logoutWithoutRequest($state, s, p, externalError, forceReload) {
        setToken(null);
        setUser(undefined);
        demoUser = false;
        clear();
        setResetFeature(true);
        //TreeFilterService.items = []; //clearTreeFilter();
        //$rootScope.$emit("clearTree");
        //TreeFilterService = {};
        if (externalError) {
          $state.go("error", { key: externalError }, { reload: true });
        } else {
          if ($state.$current.name !== s) {
            RequestService.cancelAll();
            $state.go(s, p || {}, {
              reload: true,
            });
          }
        }

        if (forceReload) {
          $timeout(() => {
            $window.location.reload(true);
          }, 100);
        }
      }

      function isAuthenticated() {
        return authenticated;
      }

      function isDemoUser() {
        var defer = $q.defer();
        if (demoUser === undefined) {
          reloadUser().then(function () {
            defer.resolve(demoUser);
          });
        } else {
          defer.resolve(demoUser);
        }
        return defer.promise;
      }

      function isSwitchedUser(user) {
        if (
          user &&
          user.actingAsUser !== undefined &&
          user.actingAsUser !== null
        ) {
          return true;
        } else {
          return false;
        }
      }

      function canAccessState(state) {
        return (state.data && !state.data.anonymousAccess) || !state.data;
      }

      function getCheckSessionTimeout() {
        return checkSessionTimeout;
      }

      function clearSessionTimeout() {
        if (checkSessionTimeout) {
          $timeout.cancel(checkSessionTimeout);
          checkSessionTimeout = null;
        }
      }

      function setCheckSessionTimeout(func, time) {
        clearSessionTimeout();
        checkSessionTimeout = $timeout(func, time);
      }

      function getUserSync() {
        return User.get();
      }

      function renavigateToLogin() {
        var browserLanguage =
          $window.navigator.language || $window.navigator.userLanguage;
        $state.go("login", {
          locale: $state.$stateParams
            ? $state.$stateParams.locale
            : browserLanguage,
        });
      }

      function getContext() {
        return context;
      }

      function setSelectedContract(id) {
        selectedContract = id;
      }

      function getSelectedContract() {
        return selectedContract;
      }

      return {
        clearSessionTimeout: clearSessionTimeout,
        getCheckSessionTimeout: getCheckSessionTimeout,
        setCheckSessionTimeout: setCheckSessionTimeout,
        getUserWithoutReload: getUserWithoutReload,
        login: login,
        logout: logout,
        logoutWithoutRequest: logoutWithoutRequest,
        canAccessState: canAccessState,
        getUser: getUser,
        setUser: setUser,
        setResetFeature,
        getResetFeature,
        reloadUser: reloadUser,
        isAuthenticated: isAuthenticated,
        isSwitchedUser: isSwitchedUser,
        showDemoInfo: showDemoInfo,
        showDemoInfoAgain: showDemoInfoAgain,
        demoInfoShown: demoInfoShown,
        isDemoUser: isDemoUser,
        getUserSync: getUserSync,
        renavigateToLogin: renavigateToLogin,
        getContext: getContext,
        setSelectedContract: setSelectedContract,
        getSelectedContract: getSelectedContract,
        clearGDPRCookies: clearGDPRCookies,
        clearCookies: clearCookies,
      };
    },
  ]).name;



// WEBPACK FOOTER //
// ./src/ui/modules/dcb-eaccount/services/AuthenticationService.js